export default __webpack_public_path__ + "static/media/support.11861e22.png";